import {
  CondenserLocationType,
  ConfigurationType,
  ExistingSystemType,
  LevelType
} from 'data/types';
import { nanoid } from 'nanoid';
import { getNextConfigurationName } from 'utils/configuration-generation';
import {
  buildWholeHouseDuctedConfiguration,
  resolveExistingSystemForLayout
} from 'utils/ducted-layout-configuration';
import { WholeHouseDuctedConfigurationType } from 'utils/whole-house-ducted-configuration-types';

export const DUCTED_DESIGN_CONFIG_BASE_NAME = 'Ducted Design';
const DUCTED_DESIGN_CONDENSER_NAME = 'Condenser 1';
const DUCTED_DESIGN_ZONE_NAME = 'Zone 1';

export type BuildDuctedDesignConfigurationParams = {
  name: string;
  structure: LevelType[];
  existingSystems: ExistingSystemType[];
  eligibleSystems: ExistingSystemType[];
  condenserLocations?: readonly CondenserLocationType[] | null;
};

export function getNextDuctedDesignConfigurationName(
  configurations: ConfigurationType[]
): string {
  return getNextConfigurationName(
    DUCTED_DESIGN_CONFIG_BASE_NAME,
    configurations
  );
}

export function resolveDuctedDesignSeedSystem(
  existingSystems: ExistingSystemType[],
  eligibleSystems: ExistingSystemType[]
): ExistingSystemType | null {
  return (
    resolveExistingSystemForLayout(existingSystems) ??
    eligibleSystems[0] ??
    null
  );
}

export function buildDuctedDesignConfiguration({
  name,
  structure,
  existingSystems,
  eligibleSystems,
  condenserLocations
}: BuildDuctedDesignConfigurationParams): WholeHouseDuctedConfigurationType | null {
  return buildWholeHouseDuctedConfiguration({
    ids: {
      configurationUniqueId: nanoid(5),
      condenserUniqueId: nanoid(5),
      zoneUniqueId: nanoid(5)
    },
    names: {
      configuration: name,
      condenser: DUCTED_DESIGN_CONDENSER_NAME,
      zone: DUCTED_DESIGN_ZONE_NAME
    },
    type: 'ducted',
    existingSystem: resolveDuctedDesignSeedSystem(
      existingSystems,
      eligibleSystems
    ),
    structure,
    condenserLocations
  });
}
